import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomOutletGridComponent } from './custom-outlet-grid.component';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';
import {CustomAddToCartModule} from '../../../../spartacus/custom/cms-components/cart/custom-add-to-cart/custom-add-to-cart.module';
import {CustomProductItemModule} from '../custom-product-item/custom-product-item.module';

@NgModule({
  declarations: [CustomOutletGridComponent],
  imports: [
    CommonModule, MediaModule, RouterModule, UrlModule,
    CustomAddToCartModule,
    CustomProductItemModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OutletGridComponent: {
          component: CustomOutletGridComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomOutletGridModule { }
